var CompanySize = {
	"Company size": "会社の規模",
	"1-19 employees": "従業員数 1～19 人",
	"20-99 employees": "従業員数 20～99 人",
	"100-499 employees": "従業員数 100～499 人",
	"500-999 employees": "従業員数 500～999 人",
	"1,000-9,999 employees": "従業員数 1,000～9,999 人",
	"10,000 employees or more": "従業員数 10,000 人以上"
};

export { CompanySize as default };
